export default __webpack_public_path__ + "static/media/Blasting Machine2.69356751.jpg";